
import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { LoadingController, NavController } from "@ionic/angular";
import * as moment from "moment-timezone";
import { GlobalsService } from "src/app/api/globals.service";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import { ToastService } from "src/app/services/toast.service";
import { ComponentDataService } from "../../services/component-data.service";
import { TimerService } from "src/app/services/timer.service";
import { StorageService } from "src/app/services/storage.service";

@Component({
  selector: "app-realizar-actividad-frame",
  templateUrl: "./realizar-actividad-frame.component.html",
  styleUrls: ["./realizar-actividad-frame.component.scss"],
})
export class RealizarActividadFrameComponent implements OnInit {
  @Input() public curso: any;
  @Input() public ID_LIBROCURSO: number;
  @Input() public ID_TIPO: number;
  @Input() public NOMBER_ACTIVIDAD: string;

  @Input() public setStep: (step: number) => void;
  private ID_ACTIVIDAD = 0;

  displayUserData: any;
  nombre_actividad: string;
  ejercicio_numero: number;
  explicacion_titulo: string;
  itemLength: number;

  current_act: number = 1;
  total_act: number = 0;

  act_h: number = 0;
  act_m: number = 0;
  act_s: number = 0;
  act_sec = 0;
  act_min = 0;
  act_hrs = 0;
  time_ejercicio = "";
  id_ejercico = "";
  id_tipo_ejercicio = "";
  tipo_ejercicio: any;
  id_ejercicoTemp = "";
  id_tipo_ejercicioTemp = "";
  idInterval: any;
  hAux: any;
  mAux: any;
  sAux: any;

  stepsActive: number = 0;
  ismobile: boolean;

  actividades: any = [];
  actividad: number;
  respuestasEjercicios: any = [];
  stepFinish = 0;
  itemLengthEmit: number;

  _SAVE_DATA: any = [];
  fecha_ini: any;
  notePuzzle: number;

  private id: number;
  public is_curso: boolean = false;
  private auth_key: string;
  public exerciseCourse: any = [];
  public respuestasActividad: any = {};
  stepAux = 0;
  inicio_actividad_key = "";

  finishActivity = false;
  finishOption = 0;
  selectedStars = 1;
  isValidExercise = false;
  globalTime: string;
  actualTime: string;
  idActividad: number;
  constructor(
    public globalsService: GlobalsService,
    public navCtrl: NavController,
    private cursosService: CursosService,
    private authService: AuthService,
    private storageService: StorageService,
    private toastService: ToastService,
    public loadingCtrl: LoadingController,
    public dataService: ComponentDataService,
    private timerService: TimerService,
    private cdr: ChangeDetectorRef
  ) {
    this.ismobile = globalsService.isMobile;
  }

  ngOnInit() {
    //this.storageService.removeItem("activities");
    this.timerService.elapsedTimeGlobal$.subscribe((elapsed) => {
      this.globalTime = elapsed;
      let time = this.globalTime.split(":").map(Number);
      this.act_h = time[0];
      this.act_m = time[1];
      this.act_s = time[2];
    });
    this.timerService.elapsedTime$.subscribe((elapsed) => {
      this.actualTime = elapsed;
      let time = this.actualTime.split(":").map(Number);
      this.act_hrs = time[0];
      this.act_min = time[1];
      this.act_sec = time[2];
    });
    this.loadUserData();
  }

  ngOnDestroy() {
    this.timerService.initTimer("00:00:00");
    this.timerService.initTimerGlobal("00:00:00");
    this.timerService.ispaused.next(false);
  }
  async loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        if (res) {
          if (!this.displayUserData) {
            this.displayUserData = res;
            this.id = this.displayUserData?.id;
            this.auth_key = this.displayUserData?.auth_key;

            resolve(true);
          }
        }
      });
    });
    promise.then((success) => {
      if (success) {
        this.nombre_actividad = this.NOMBER_ACTIVIDAD;
        this.ejercicio_numero = 1;
        this.cursosService
          .realizarActividadEstudianteCurso(
            this.id,
            this.curso.id,
            this.auth_key,
            this.ID_LIBROCURSO,
            this.ID_TIPO
          )
          .subscribe((response) => {
            this.idActividad = response[0].data[0].id;
            this.actividades = response[0].activities.map((item, index) => ({
              ...item,
              active: index === 0,
              time: item.time ? item.time : "00:00:00",
            }));
            this.createStorageData(this.idActividad);
            this.total_act = this.actividades.length;
          });
      }
    });
    if (this.actividad == 6) {
      this.itemLength = this.storageService.AskItems;
    }
  }

  createStorageData(id_actividad) {
    this.storageService.get("activities").then((res) => {
      if (
        !res ||
        !res.find(
          (x) => x.id == this.curso.id && x.id_actividad == id_actividad
        )
      ) {
        this.timerService.initTimer("00:00:00");
        this.timerService.initTimerGlobal("00:00:00");
        let tempActivities: any = {
          id: this.curso.id,
          id_user: this.id,
          globalTime: this.globalTime,
          id_actividad: id_actividad,
          data: [],
        };
        this.storageService.storage(
          "activities",
          !res ? [tempActivities] : [...res, tempActivities]
        );
      } else {
        let data = res.find(
          (x) => x.id == this.curso.id && x.id_actividad == id_actividad
        );
        // le asigna los timepos de cada actividad si los tiene
        this.actividades.forEach((element) => {
          let find = data.data.find((x) => x.id == element.data.id);
          element.time = find.time;
          if (element.active) {
            this.timerService.initTimer(element.time);
          }
        });
        this.timerService.initTimerGlobal(data.globalTime);
      }
    });
  }

  dataSqlite: any;

  qualifyNote(items, timeEnd) {
    let timeConvert;
    let timeMed;

    let parts = timeEnd.split(":");
    let hours = +parts[0];
    let minutes = +parts[1];
    let seconds = +parts[2];
    timeConvert = hours * 3600 + minutes * 60 + seconds;

    timeMed = timeConvert / items;

    switch (true) {
      case timeMed <= 10:
        this.notePuzzle = 5;
        break;

      case timeMed > 10 && timeMed <= 15:
        this.notePuzzle = 4;
        break;

      case timeMed > 15 && timeMed <= 20:
        this.notePuzzle = 3;
        break;

      case timeMed > 20 && timeMed <= 25:
        this.notePuzzle = 2;
        break;

      case timeMed > 25 && timeMed <= 30:
        this.notePuzzle = 1;
        break;

      default:
        this.notePuzzle = 0;
        break;
    }
  }

  async iniciarActividad() {
    let fInicio = moment(new Date().toISOString());
    let fecha_format = null;

    let _id_curso = this.curso.id;
    let _id_librocurso = this.ID_LIBROCURSO;
    let _id_user = this.id;

    let _tipo = this.ID_TIPO;
    const key = `inicio_actividad_${_id_curso}_${_id_librocurso}_${_id_user}_${_tipo}`;
    this.inicio_actividad_key = key;

    await this.storageService.removeItem(key);
    let inicio_actividad: any = await this.storageService.get(key);
    if (!inicio_actividad) {
      fecha_format = fInicio.format("YYYY-MM-DD HH:mm:ss");
      let data = {
        actividad_key: this.inicio_actividad_key,
        id_curso: this.curso.id,
        id_librocurso: this.ID_LIBROCURSO,
        id_user: this.id,
        tipo: this.ID_TIPO,
        terminado: false,
        save: false,
        fecha_inicio: fInicio,
        fecha_fin: null,
        data: null,
      };
      await this.storageService.storage(key, data);
    }
    return await this.cursosService
      .iniciarActividad(
        this.id,
        this.curso.id,
        this.auth_key,
        this.ID_LIBROCURSO,
        this.ID_TIPO,
        fecha_format
      )
      .toPromise();
  }

  iniciarEjercicio(id_tipo, id_ejercicio, time) {
    return this.cursosService.iniciarEjercicio(
      this.id,
      this.auth_key,
      this.ID_ACTIVIDAD,
      this.curso.id,
      time,
      id_tipo,
      id_ejercicio
    );
  }

  cargarEjercicio() {
    return this.cursosService.cargarEjercicio(
      this.id,
      this.auth_key,
      this.ID_ACTIVIDAD,
      this.curso.id,
      this.time_ejercicio,
      this.id_tipo_ejercicio,
      this.id_ejercico
    );
  }

  stepMinus() {
    // se setea el tiempo del ejercicio actual en el storage
    this.storageService.setTimerExercice(
      "activities",
      this.actividades[this.stepsActive].data.id,
      this.actividades[this.stepsActive].data.id_actividad,
      this.actualTime,
      this.globalTime
    );
    if (this.finishActivity) {
      this.timerService.initTimer(this.actividades[this.stepsActive].time);
      this.timerService.ispaused.next(false);
      this.finishActivity = false;
      return;
    }
    if (this.stepsActive > 0) {
      // inactiva el ejercicio actual y le asigna su tiempo
      this.actividades[this.stepsActive].active = false;
      this.actividades[this.stepsActive].time = this.actualTime;
      // activa el ejercicio anterior y le asigna su tiempo
      this.stepsActive--;
      this.current_act--;
      this.actividades[this.stepsActive].active = true;
      this.timerService.initTimer(this.actividades[this.stepsActive].time);
      this.setStep(this.stepsActive);
      this.isValidExercise = true;
    }

    if (this.stepsActive == 0) {
      this.navCtrl.navigateRoot(`cursos/estudiante-curso/${this.curso.id}`);
      return;
    }
  }

  stepMore() {
    this.isValidExercise = false;
    // se setea el tiempo del ejercicio actual en el storage
    this.storageService.setTimerExercice(
      "activities",
      this.actividades[this.stepsActive].data.id,
      this.actividades[this.stepsActive].data.id_actividad,
      this.actualTime,
      this.globalTime
    );
    if (this.stepsActive < this.actividades.length - 1) {
      // inactiva el ejercicio actual y le asigna su tiempo
      this.actividades[this.stepsActive].active = false;
      this.actividades[this.stepsActive].time = this.actualTime;
      console.log(this.actividades);
      // activa el ejercicio siguiente y le asigna su tiempo si lo tiene si no lo inicia en 00:00:00
      this.stepsActive++;
      this.current_act++;
      this.actividades[this.stepsActive].time
        ? this.timerService.initTimer(this.actividades[this.stepsActive].time)
        : this.timerService.initTimer("00:00:00");
      this.actividades[this.stepsActive].active = true;
      this.setStep(this.stepsActive);
    } else {
      this.actividades[this.stepsActive].time = this.actualTime;
      this.setStep(this.stepsActive);
      this.finishActivity = true;
      this.timerService.ispaused.next(true);
    }
  }

  async finalizarActividad() {
    let datosActividad = {
      id_curso: this.curso.id,
      id_librocurso: this.ID_LIBROCURSO,
      id_user: this.id,
      tipo: this.ID_TIPO,
      notePuzzle: this.notePuzzle,
    };
    const now = new Date();
    let fechaCO_fin = moment(now);
    const fecha_format_fin = fechaCO_fin
      .tz("America/Bogota")
      .format("YYYY-MM-DD HH:mm:ss");
    await this.storageService.get("activities").then((resp: any[]) => {
      const dataSend = {
        data: datosActividad,
        actividades:
          resp
            .find(
              (x) => x.id == this.curso.id && x.id_actividad == this.idActividad
            )
            ?.data.map((item) => ({
              ...item,
              id_curso: this.curso.id, // o el valor fijo que tú quieras
            })) || [],
        fechafin: fecha_format_fin,
        notePuzzle: this.notePuzzle,
      };
      this.showLoader();
      this.cursosService.enviarActividad(dataSend).subscribe(
        (response) => {
          if (
            response &&
            response.statusCode >= 200 &&
            response.statusCode <= 299
          ) {
            this.toastService.presentToast("Se he registrado su actividad");
            this.dataService.itemSelectedMenu.next({
              menu: "contentCurse",
              componente: 1,
            });
            this.timerService.ispaused.next(false);
          } else {
            this.toastService.presentToast("Error al registrar la actividad");
          }
          this.hideLoader();
        },
        (error) => {
          this.toastService.presentToast("Error al registrar la actividad");
          this.hideLoader();
        }
      );
    });
  }
  SendingData: boolean = false;
  ActionSendData: boolean = false;
  executeR = 0;

  async envioRespuestas(datosActividad: any, data, trigger) {
    this.respuestasActividad["data"] = datosActividad;
    let fecha_fin = moment(new Date().toISOString());
    const now = new Date();
    this.executeR++;
    let fechaCO_fin = moment(now);
    const fecha_format_fin = fechaCO_fin
      .tz("America/Bogota")
      .format("YYYY-MM-DD HH:mm:ss");

    this.respuestasActividad["fechafin"] = fecha_format_fin;
    let sqliteData = null;
    this.respuestasActividad["notePuzzle"] = this.notePuzzle;
    if (!this.ismobile) {
      await this.storageService.get("activities").then(async (resp2: any[]) => {
        const inicio_actividad_data: any = await this.storageService.get(
          this.inicio_actividad_key
        );

        resp2.find(async (data2) => {
          if (data2.data.length == 0 && !this.SendingData) {
            this.SendingData = true;
            inicio_actividad_data.terminado = true;
            inicio_actividad_data.fecha_fin = fecha_format_fin;

            inicio_actividad_data.data = this.respuestasActividad;
            await this.storageService.storage(
              this.inicio_actividad_key,
              inicio_actividad_data
            );
            this.showLoader();
            let response = await this.cursosService.finalizarActividad(
              inicio_actividad_data.data
            );

            if (
              response &&
              response.statusCode >= 200 &&
              response.statusCode <= 299
            ) {
              inicio_actividad_data.save = true;
              await this.storageService.storage(
                this.inicio_actividad_key,
                inicio_actividad_data
              );
              await this.toastService.presentToast(
                "Se he registrado su actividad"
              );
              this.hideLoader();
              this.dataService.itemSelectedMenu.next(1);
              this.timerService.ispaused.next(false);
            }
          }
          let send = false;
          data2.data.forEach(async (element, i, arr) => {
            if (i == arr.length - 1 && this.executeR == trigger) {
              send = true;
            }
            if (
              element.id_actividad === this.ID_ACTIVIDAD &&
              element.id === data.id_ejercicio &&
              element.id_tipo === data.id_tipo
            ) {
              await this.respuestasActividad["actividades"].push(element);
            }
            if (!this.SendingData && send) {
              this.SendingData = true;
              inicio_actividad_data.terminado = true;
              inicio_actividad_data.fecha_fin = fecha_format_fin;
              await (inicio_actividad_data.data = this.respuestasActividad);
              this.showLoader();
              let response = await this.cursosService.finalizarActividad(
                this.respuestasActividad
              );
              if (
                response &&
                response.statusCode >= 200 &&
                response.statusCode <= 299
              ) {
                inicio_actividad_data.save = true;
                await this.storageService.storage(
                  this.inicio_actividad_key,
                  inicio_actividad_data
                );
                await this.toastService.presentToast(
                  "Se he registrado su actividad"
                );
                this.hideLoader();
                this.dataService.itemSelectedMenu.next(1);
                this.timerService.ispaused.next(false);
              } else {
                await this.storageService.storage(
                  this.inicio_actividad_key,
                  inicio_actividad_data
                );
                await this.toastService.presentToast(
                  "Se he almacenado su actividad"
                );
              }
            } else if (i == arr.length - 1) {
              if (inicio_actividad_data.terminado) {
                this.dataService.itemSelectedMenu.next(1);
                alert("Esta actividad ya se realizó!!!!!");
              }
            }
          });
        });
      });
    }
    return true;
  }

  sendData() {
    let DATA: any;
    this.storageService.get("activities").then((res: any) => {
      if (res) {
        DATA = {
          id_actividad: this.ID_LIBROCURSO,
          reSend: false,
          id_user: this.id,
          tiempo_total: "",
          tiempo_init: this.fecha_ini,
          data: [],
        };
        res.forEach((element) => {
          if (this.curso.id == element.id) {
            let data: any = element.data;
            data.forEach((element2, i) => {
              if (element2.id_actividad == this.ID_ACTIVIDAD) {
                DATA.data.push(element2);
              }
            });
          } else {
          }
        });
      } else {
      }
    });
  }

  async getStorage() {
    return await this.storageService.get("activities").then((res: any) => {
      if (res) {
        res.forEach((element) => {
          if (this.curso.id == element.id) {
            let data: any = element.data;
            data.forEach((element2, i) => {
              if (element2.id_actividad == this.ID_ACTIVIDAD) {
                return element2;
              }
            });
          } else {
          }
        });
      } else {
      }
    });
  }

  insertStorageExercise(op = 0) {
    this.loadUserData();
    this.qualifyNote(this.itemLength, this.time_ejercicio);
    let response: any;
    if (op == 1) {
      return new Promise((resolve, reject) => {
        resolve({});
      });
    } else {
      return this.storageService.get("ejercicios").then(
        (resp: any) => {
          if (resp) {
            const findData = resp.findIndex((data) => {
              return (
                data.id_ejercicio === this.id_ejercico &&
                data.id_tipo === this.id_tipo_ejercicio &&
                data.id_actividad === this.ID_ACTIVIDAD &&
                data.id_curso === this.curso.id &&
                data.id_user === this.id &&
                data.tipo == this.tipo_ejercicio
              );
            });
            const data = {
              id_ejercicio: this.id_ejercico,
              id_tipo: this.id_tipo_ejercicio,
              tipo: this.tipo_ejercicio,
              time: this.time_ejercicio,
              id_actividad: this.ID_ACTIVIDAD,
              id_curso: this.curso.id,
              id_user: this.id,
              notePuzzle: this.notePuzzle,
            };

            resp[findData] = data;
            this.storageService.storage("ejercicios", resp);
            response = {
              error: false,
              validate: true,
              insert: false,
            };
          }
          return response;
        },
        (err: any) => {
          response = {
            error: true,
            validate: false,
            insert: false,
          };
          return response;
        }
      );
    }
  }

  cargarStorageExercise() {
    let response: any;
    return this.storageService.get("ejercicios").then((resp: any[]) => {
      if (resp) {
        const findData = resp.find((data) => {
          return (
            data.id_ejercicio === this.id_ejercico &&
            data.id_tipo === this.id_tipo_ejercicio &&
            data.id_actividad === this.ID_ACTIVIDAD &&
            data.id_curso === this.curso.id &&
            data.id_user === this.id &&
            data.tipo == this.tipo_ejercicio
          );
        });
        if (findData) {
          response = findData;
        } else {
          const data = {
            id_ejercicio: this.id_ejercico,
            id_tipo: this.id_tipo_ejercicio,
            tipo: this.tipo_ejercicio,
            time: "00:00:00",
            id_actividad: this.ID_ACTIVIDAD,
            id_curso: this.curso.id,
            id_user: this.id,
            notePuzzle: this.notePuzzle,
          };
          resp.push(data);
          this.storageService.storage("ejercicios", resp);
          response = data;
        }
        return response;
      } else {
        const data = {
          id_ejercicio: this.id_ejercico,
          id_tipo: this.id_tipo_ejercicio,
          tipo: this.tipo_ejercicio,
          time: "00:00:00",
          id_actividad: this.ID_ACTIVIDAD,
          id_curso: this.curso.id,
          id_user: this.id,
          notePuzzle: this.notePuzzle,
        };
        this.exerciseCourse.push(data);
        this.storageService.storage("ejercicios", this.exerciseCourse);
        response = data;
        return response;
      }
    });
  }

  finish() {
    this.finalizarActividad();
  }

  isStarSelected(starIndex: number): boolean {
    return starIndex <= this.selectedStars;
  }

  selectStar(starIndex: number) {
    this.selectedStars = starIndex;
  }

  isvalid(value: boolean) {
    this.isValidExercise = value;
  }
  @Input()
  name(value: string) {
    this.explicacion_titulo = value;
    this.cdr.detectChanges();
  }

  showLoader() {
    this.loadingCtrl
      .create({
        message: "Procesando...",
      })
      .then((res) => {
        res.present();
        res.onDidDismiss().then((dis) => {});
      });
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingCtrl.dismiss();
    }, 200);
  }
}
